import React, { useState, useEffect } from 'react';
import api from '../../../../../config/axios';
import Swal from 'sweetalert2';

import { FaRegSave, FaTimes } from 'react-icons/fa';

const BancoModal = ({ banco, onClose, onBancoAtualizado }) => {
    const [formData, setFormData] = useState({
        codigo: '',
        nome: ''
    });
    const [tituloModal, setTituloModal] = useState("");

    useEffect(() => {
        if (banco != null) {
            setFormData({
                codigo: banco.codigo || '',
                nome: banco.nome || ''
            });
            setTituloModal('Editar Banco');
        } else {
            setTituloModal('Novo Banco');
        }
    }, [banco]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.codigo.trim()) {
            Swal.fire('Atenção', 'O código do banco é obrigatório.', 'warning');
            return;
        }

        if (formData.codigo.length < 3) {
            Swal.fire('Atenção', 'O código do banco deve ter 3 dígitos.', 'warning');
            return;
        }

        if (!formData.nome.trim()) {
            Swal.fire('Atenção', 'O nome do banco é obrigatório.', 'warning');
            return;
        }

        Swal.fire({
            title: "Carregando...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            if (banco) {
                await api.put(`/bancos/${banco.id}`, formData);
                Swal.fire("Sucesso", "Banco atualizado com sucesso!", "success");
            } else {
                await api.post('/bancos', formData);
                Swal.fire("Sucesso", "Banco criado com sucesso!", "success");
            }

            onBancoAtualizado();
        } catch (error) {
            Swal.close();
            Swal.fire('Erro', error.response.data.message || 'Erro ao salvar banco.', 'error');
        }
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-md modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">{tituloModal}</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12">
                                    <label className="form-label fw-bold">Código</label>
                                    <input
                                        type="text"
                                        name="codigo"
                                        className="form-control"
                                        value={formData.codigo}
                                        onChange={handleChange}
                                        maxLength={3}
                                        required
                                        autoComplete="off"
                                    />
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12">
                                    <label className="form-label fw-bold">Nome</label>
                                    <input
                                        type="text"
                                        name="nome"
                                        className="form-control"
                                        value={formData.nome}
                                        onChange={handleChange}
                                        maxLength={100}
                                        required
                                        autoComplete="off"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer mt-4">
                            <div className="row">
                                <div className="col-12 text-end">
                                    <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                                        <FaTimes /> Fechar
                                    </button>
                                    <button className="btn btn-custom-primary ms-3" type="submit">
                                        <FaRegSave /> Salvar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default BancoModal; 